package tables.ad

import emotion.react.css
import entities.Ad
import kotlinx.browser.window
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.table
import react.dom.html.ReactHTML.tbody
import react.dom.html.ReactHTML.td
import react.dom.html.ReactHTML.th
import react.dom.html.ReactHTML.thead
import react.dom.html.ReactHTML.tr
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.BorderCollapse
import web.cssom.Color
import web.cssom.TextAlign
import web.cssom.px
import web.html.InputType

external interface AdsProps : Props

val AdsTable = FC<AdsProps> {

    val (ads, setAds) = useState(emptyList<Ad>())
    var adName by useState("")
    var isModalOpenUpdate: Ad? by useState(null)
    var isModalOpenCreate by useState(false)

    fun loadAds() {
        window.fetch(urlAddress + "api/ads", RequestInit(
            method = "GET",
            headers = web.http.Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    Ad(
                        it.id as? Int ?: 0,
                        it.name as? String ?: "",
                        it.message as? String ?: ""
                    )
                }
                setAds(newResultList)
            }
    }

    useEffect(ads.isEmpty()) {
        loadAds()
    }

    UpdateAdModal {
        ad = isModalOpenUpdate
        onClose = {
            isModalOpenUpdate = null
        }
        onUpdate = {
            loadAds()
        }
    }

    CreateAdModal {
        isOpen = isModalOpenCreate
        onClose = {
            isModalOpenCreate = false
        }
        onUpdate = {
            loadAds()
        }
    }

    div {
        div {
            +"Введите наименование Рекламы:"
            input {
                css {
                    fontSize = 14.px
                }
                value = adName
                type = InputType.text
                onChange = { event ->
                    adName = event.target.value
                }
            }
            button {
                +"Добавить"
                onClick = {
                    isModalOpenCreate = true
                }
            }
        }

        table {
            border = 1
            css {
                borderColor = Color("#000")
                borderCollapse = BorderCollapse.collapse
                textAlign = TextAlign.center
            }
            thead {
                tr {
                    th { +"Наименование" }
                    th { +"Сообщение" }
                    th { +"Действие" }
                }
            }
            tbody {
                ads.filter { it.name.lowercase().contains(adName.lowercase()) }.forEach { item ->
                    tr {
                        td { +item.name }
                        td { +item.message }
                        td {
                            button {
                                css {
                                    margin = 5.px
                                    marginBottom = 5.px
                                    fontSize = 14.px
                                }
                                +"✏️"
                                onClick = {
                                    isModalOpenUpdate = item
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

